module.exports = __webpack_public_path__ + "fonts/2tsd397wLxj96qwHyNIkxHYhjbSpvc47ee6xR_80Hnw.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/roboto-font/2tsd397wLxj96qwHyNIkxHYhjbSpvc47ee6xR_80Hnw.woff2
// module id = 317
// module chunks = 0